import { graphql } from '@teachino/shared-infrastructure';
import { featureFragment } from './feature.fragment';

export const tenantLicenseFragment = graphql(
  `
    fragment TenantLicense on License {
      id
      cycleStartAt
      cycleRenewalAt
      expiresAt
      tenant {
        id
        name
      }
      plan {
        id
        features {
          ...Feature
        }
        key
        type
      }
    }
  `,
  [featureFragment],
);
